import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';

const iitStyle={
	backgroundImage: 'url("../img/w1.png")',
	backgroundRepeat:'no-repeat',
	backgroundPosition:'center',
	backgroundSize:'cover'
}

// ES6 class-style
class Why extends PreLoginSessionCheck {
  render() {
  	return(
	<section className="mtb whyhm why-heymath">
		<div className="row">
			<div className="container">
				<h2>Why HeyMath!</h2> 
				<div className="row">
					<div className="col-md-8">
						<div className="w-hmth">
							<div className="w-left bg-inline" role="img" aria-label="HeyMath! employees group photo" style={iitStyle}></div>
							<div className="w-right "> 
								<h4>Backed by a team of passionate professionals from Cambridge, IIM, IIT and NID</h4>
								<p>In May 2000, a group of talented people who love &amp;  live Maths came together to spread their enthusiasm for the subject. They observed classroom practices of the finest of Math teachers around the world. The HeyMath! team then digitised its learnings into curriculum solutions that help every student achieve his or her best potential in Math. </p>
							</div>
						</div>
						<div className="w-hmth">
							<div className="w-left res-right"><img src="../img/w2.png" alt="University of Cambridge logo"/></div>
							<div className="w-right res-left"> 
								<h4>Proven methodology that has successfully impacted 1 million students and 5000 teachers in 50 countries</h4>
								<p>Right from our inception, experts at the University of Cambridge have helped shape HeyMath's rich teaching methodologies. Our approach is to strengthen conceptual understanding by emphasizing on both the 'why' and the 'how' and using real life contexts and interactive activities to drive the learning deeper. Our adaptive assessments provide personalised learning paths for students to achieve mastery.</p>
							</div>
						</div>
						</div>		
					<div className="col-md-4"> 
						<div className="w-hmth w-col4">
							<div className="left"><img src="../img/w3.jpg" alt="Maths & Interdisciplinary representation"/></div>
							<div className="right"> 
								<h4>We are much more than Math! We think interdisciplinary</h4>
								<p>What will set a student apart in the 21st century is multi-disciplinary thinking, creativity and problem solving skills. HeyMath! has been a pioneer in making interdisciplinary connections between <a href="https://timesofindia.indiatimes.com/city/bengaluru/A-workshop-where-kids-can-learn-music-through-maths/articleshow/55611063.cms" target="_blank" className="btn-links" data-ga="Home - Why HeyMath! - Music & Math">Math and Music</a>, <a href="http://www.thehindu.com/features/education/college-and-university/a-double-helix-lesson-to-beat-world-records/article7774567.ece" target="_blank" className="btn-links" data-ga="Home - Why HeyMath! - Math & DNA">Math and DNA</a>, <a href="https://youtu.be/A1LMAOyhghI?list=PLTlcLjeiG_8uTAVrxk5frfWPeNKu208h8" target="_blank" className="btn-links" data-ga="Home - Why HeyMath! - Math in Art History and Culture">Math in Art History and Culture</a>.</p>
							</div>
							</div>
						</div>		
					</div>
			</div>
		</div>
	</section>
  	);
  }
}

export default Why;



// WEBPACK FOOTER //
// ./src/prelogin/src/components/Why.js